import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {TemperamentoDetail} from "./temperamento-detail";

const TemperamentoDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/temperamentos');
    }

    return (
        <TemperamentoDetail id={id} onClose={onClose}/>
    )

});

export default TemperamentoDetailPage;